var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBuildings = function SvgBuildings(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 8.88889V20H5.45455V13.3333H9.81818V20H15.2727V8.88889L7.63636 3.33333L0 8.88889Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.81818 0V2.18889L17.4545 7.74445V8.88889H19.6364V11.1111H17.4545V13.3333H19.6364V15.5556H17.4545V20H24V0H9.81818ZM19.6364 6.66667H17.4545V4.44444H19.6364V6.66667Z",
    fill: "currentColor"
  })));
};
export default SvgBuildings;